import styled, { keyframes } from "styled-components";

import bgImg from "../../../assets/senai-fundo.jpg";
import { FaCheck } from "react-icons/fa";

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const FormCadastro = styled.form`
  max-width: 80%;
  width: 600px;
  height: fit-content;
  z-index: 2;
  margin: 0px 10px;

  animation: ${fadeIn} 0.3s;

  background-color: var(--white);
  padding: 30px;
  border-radius: 10px;
  color: var(--black);
  box-shadow: 0px 0px 10px;

  display: flex;
  flex-direction: column;

  > img {
    width: 100%;
    border-radius: 20px;

    margin-bottom: 10px;
  }

  > h1 {
    font-size: 30px;
    text-align: center;
    margin-bottom: 20px;

    @media (max-width: 450px) {
      font-size: 22px;
    }
  }
`;

export const Concluido = styled.div`
  max-width: 80%;
  width: 600px;
  height: fit-content;
  z-index: 2;
  margin: 0px 10px;

  animation: ${fadeIn} 0.3s;

  background-color: var(--white);
  padding: 30px;
  border-radius: 10px;
  color: var(--black);
  box-shadow: 0px 0px 10px;

  display: flex;
  flex-direction: column;
  align-items: center;

  font-size: 32px;
  text-align: center;

  > p {
    margin: 10px;
    font-size: 16px;
  }
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const AnimatedDone = styled(FaCheck)`
  size: 200;
  color: var(--alertSucesso);

  animation: ${rotate} 0.4s ease-out;
`;
